import React from "react";

import { GMN } from "@nens/brostar/openapi-client";

import { SearchBox } from "@/components/searchbox";

import { gmnInformation } from "../types";

type Props = {
  searchField: keyof GMN;
  setSearchField: (searchField: keyof GMN) => void;
  searchString: string;
  setSearchString: (searchString: string) => void;
};

const GmnFilters: React.FC<Props> = ({
  searchField,
  setSearchField,
  searchString,
  setSearchString,
}) => {
  return (
    <SearchBox
      searchField={searchField}
      setSearchField={setSearchField}
      searchString={searchString}
      setSearchString={setSearchString}
      searchOptions={gmnInformation}
    />
  );
};

export { GmnFilters };
